import React from "react";

function DigitalWalletApproveIcon({ stroke = "#12B76A" }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.375 4.375L5.83333 9.91667L3.20833 7.29167"
        stroke={stroke}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DigitalWalletApproveIcon;
